const libPictView = require('pict-view');

class PrinterCodes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
	}
}

module.exports = PrinterCodes;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'PrinterCodes',
		DefaultRenderable: 'PrinterCodes',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'PrinterCodes-Wrapper',
				Template: /*html*/`
				<section id="PrinterCodes" class="form p-5">
					<h2 class="title is-4 mb-3">Printer Codes</h2>
					<div class="content">
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Open the cart" action to start a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-OpenPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/open/cart', { printStyle: 'thin', raw: true, footers: ['HLLOGO Open Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-shopping"></i>
									</span>
									Print "Open Cart" Code
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Clear the cart" action during a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-ClearPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/clear', { printStyle: 'thin', raw: true, footers: ['HLLOGO Clear Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-circle-xmark"></i>
									</span>
									Print "Clear Cart" Code
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>A scan code for the "Submit the Cart" action to submit a scan session.</em>
							</div>
							<div class="column is-3">
								<button 
									type="button"
									id="QRPanel-SubmitPrint" 
									class="button is-link is-fullwidth" 
									onclick="_Pict.providers.QRCodeProvider.print('action/submit', { printStyle: 'thin', raw: true, footers: ['HLLOGO Submit Scanning Cart']});"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-cart-shopping-fast"></i>
									</span>
									Print "Submit" Code
								</button>
							</div>
						</div>
					</div>
				</section>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'PrinterCodes',
				TemplateHash: 'PrinterCodes-Wrapper',
				RenderMethod: 'replace',
			} ],
	});
